import { collection, getDocs } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../../firebase";
import { getAuth } from "firebase/auth";

/**
 * Fetches top-level pending submission folders for the authenticated admin user.
 * Returns an array of folder objects with folderId, folderName, and status.
 */
export async function fetchPendingFolders() {
  try {
    const submissionsRef = collection(db, "submissions");
    const querySnapshot = await getDocs(submissionsRef);
    const submissions = [];

    for (const docSnap of querySnapshot.docs) {
      const data = docSnap.data();

      submissions.push({
        id: docSnap.id,
        ...data,
      });
    }
    console.log("[DEBUG][ADMIN][TITLE] Fetch Submissions");
    console.log("[DEBUG][ADMIN] Submissions: ", submissions);
    return submissions;
  } catch (error) {
    console.error("Error fetching submissions:", error);
    return [];
  }
}

/**
 * Fetches subfolders for a given pending submission folderId for the authenticated admin user.
 * Returns an array of subfolder objects with id and subfolderName.
 */
export async function fetchPendingSubfolders(userId, folderId) {
  try {
    if (!userId || !folderId) {
      throw new Error("Missing userId or folderId");
    }

    const subfoldersSnapshot = await getDocs(
      collection(db, `users/${userId}/folders/${folderId}/subfolders`)
    );

    const subfolders = subfoldersSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        subfolderName: data.subfolderName || "Unnamed Subfolder",
      };
    });

    return subfolders;
  } catch (error) {
    console.error("Error fetching pending subfolders:", error);
    return [];
  }
}

/**
 * Fetches files for a given pending submission folderId and subfolderId for the authenticated admin user.
 * Returns an array of file objects with id, file data, and downloadURL.
 */
export async function fetchPendingFiles(userId, folderId, subfolderId) {
  try {
    if (!userId || !folderId || !subfolderId) {
      throw new Error("Missing userId, folderId or subfolderId");
    }

    const filesSnapshot = await getDocs(
      collection(
        db,
        `users/${userId}/folders/${folderId}/subfolders/${subfolderId}/files`
      )
    );

    const files = [];

    for (const fileDoc of filesSnapshot.docs) {
      const fileId = fileDoc.id;
      const fileData = fileDoc.data();
      const fileName = fileData.fileName || "Unnamed File";

      // Construct storage path
      const storagePath = `users/${userId}/folders/${folderId}/${fileData.subfolderName}/${fileName}`;

      let downloadURL = "";
      try {
        const fileRef = ref(storage, storagePath);
        downloadURL = await getDownloadURL(fileRef);
      } catch (err) {
        console.warn("Failed to get download URL for", fileName, err);
      }

      files.push({
        id: fileId,
        ...fileData,
        downloadURL,
      });
    }

    return files;
  } catch (error) {
    console.error("Error fetching pending files:", error);
    return [];
  }
}
